import script from "./CreateShopItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateShopItem.vue?vue&type=script&lang=ts&setup=true"

import "./CreateShopItem.vue?vue&type=style&index=0&id=68793e96&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68793e96"]])

export default __exports__